import script from "./sport-live-tv-row.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-row.vue?vue&type=script&setup=true&lang=js"

import "./sport-live-tv-row.vue?vue&type=style&index=0&id=b80c90a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b80c90a6"]])

export default __exports__